import React, { FC, useCallback, useState } from "react";
import { GateDialog } from "@smartsuite/react-ui/lib/components/modals/GateDialog/GateDialog";
import { InputFieldStyles } from "@smartsuite/react-ui/lib/components/forms/InputField/InputField.constants";
import {
  RoundButton,
  roundButtonStylesLarge,
} from "@smartsuite/react-ui/lib/components/buttons/RoundButton";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { useInputGroupState } from "@smartsuite/react-ui/lib/hooks/useInputGroupState/useInputGroupState";
import { TextFieldGroup } from "@smartsuite/react-ui/lib/components/forms/TextFieldGroup/TextFieldGroup";
import { FormPasscodeRequiredText } from "./FormPasscodeRequired.text";
import { $t } from "../../utils/intl";
import { FormNotFoundMessageText } from "../FormNotFoundMessage/FormNotFoundMessage.text";
import "./FormPasscodeRequired.sass";

type FormPasscodeRequiredProps = {
  title: string;
  isError?: boolean;
  onSubmit: (password: string | null) => void;
};

const inputStyles: InputFieldStyles = {
  borderColor: "transparent",
  borderHoverColor: "transparent",
  borderFocusColor: "transparent",
  borderRadius: 100,
  height: 40,
  gutters: 20,
};

export const FormPasscodeRequired: FC<FormPasscodeRequiredProps> = ({
  isError,
  title,
  onSubmit,
}) => {
  const { state, onBlur, onFocus } = useInputGroupState(isError);
  const [password, setPassword] = useState<string | null>(null);

  const handleOnSubmit = useCallback(() => {
    onSubmit(password);
  }, [onSubmit, password]);

  return (
    <div className="form-passcode-required">
      <img
        src="/images/form-404-rectangles.svg"
        alt={$t(FormNotFoundMessageText.imgAlt)}
        className="form-passcode-required__background-image"
      />
      <GateDialog
        iconName="lock"
        title={title}
        description={$t(FormPasscodeRequiredText.description)}
        className="passcode-required-modal"
      >
        <div className="passcode-required-modal__form">
          <TextFieldGroup
            type="password"
            inputGroupState={state}
            placeholder={$t(FormPasscodeRequiredText.enterPassword)}
            inputStyles={inputStyles}
            inputGroupClass="passcode-required-modal__input"
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={(event) => setPassword(event.target.value)}
          />

          {isError && (
            <Text
              tag="div"
              color="error"
              className="passcode-required-modal__error"
              ariaLabel="Error message"
            >
              {$t(FormPasscodeRequiredText.passcodeIsIncorrect)}
            </Text>
          )}

          <RoundButton
            styles={roundButtonStylesLarge}
            className="passcode-required-modal__submit"
            ariaLabel="Enter Button"
            onClick={handleOnSubmit}
          >
            {$t(FormPasscodeRequiredText.enter)}
          </RoundButton>
        </div>
      </GateDialog>
    </div>
  );
};
